import React, { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import AdminOrders from "./admin/AdminOrders";
import AdminMetrics from "./admin/AdminMetrics";
import AdminProducts from "./admin/AdminProducts";
import AdminCategories from "./admin/AdminCategories";
import AdminSettings from "./admin/AdminSettings";
import AdminCustomers from "./admin/AdminCustomers";
import AdminCampaigns from "./admin/AdminCampaigns";
import AdminCosts from "./admin/AdminCosts";
import { LayoutDashboard, BarChart3, Package, Tags, Settings, Users, Megaphone, Calculator } from "lucide-react";

const TABS = [
  { value: "orders", label: "Pedidos", icon: LayoutDashboard, roles: ["admin", "operator"] },
  { value: "metrics", label: "Métricas", icon: BarChart3, roles: ["admin", "operator"] },
  { value: "products", label: "Productos", icon: Package, roles: ["admin"] },
  { value: "categories", label: "Categorías", icon: Tags, roles: ["admin"] },
  { value: "customers", label: "Base de datos", icon: Users, roles: ["admin"] },
  { value: "campaigns", label: "Campañas", icon: Megaphone, roles: ["admin"] },
  { value: "costs", label: "Calculadora de costos", icon: Calculator, roles: ["admin"] },
  { value: "settings", label: "Ajustes", icon: Settings, roles: ["admin"] },
];

export default function AdminDashboard() {
  const { user } = useAuth();
  const [tab, setTab] = useState("orders");
  const visibleTabs = TABS.filter((t) => t.roles.includes(user?.role));

  return (
    <div className="max-w-[1600px] mx-auto px-3 sm:px-6 lg:px-10 py-6 lg:py-8" data-testid="admin-dashboard">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
        <div>
          <div className="text-xs font-mono uppercase text-neutral-500">/admin · {user?.role}</div>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter mt-1">Panel de control</h1>
        </div>
      </div>

      <div className="border-b border-neutral-200 mb-8 overflow-x-auto">
        <div className="flex gap-1">
          {visibleTabs.map((t) => (
            <button
              key={t.value}
              onClick={() => setTab(t.value)}
              className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 whitespace-nowrap ${
                tab === t.value ? "border-black text-black" : "border-transparent text-neutral-500 hover:text-black"
              }`}
              data-testid={`admin-tab-${t.value}`}
            >
              <t.icon className="w-4 h-4" />
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "orders" && <AdminOrders />}
      {tab === "metrics" && <AdminMetrics />}
      {tab === "products" && user?.role === "admin" && <AdminProducts />}
      {tab === "categories" && user?.role === "admin" && <AdminCategories />}
      {tab === "customers" && user?.role === "admin" && <AdminCustomers />}
      {tab === "campaigns" && user?.role === "admin" && <AdminCampaigns />}
      {tab === "costs" && user?.role === "admin" && <AdminCosts />}
      {tab === "settings" && user?.role === "admin" && <AdminSettings />}
    </div>
  );
}
